import React, { useEffect, useState } from "react";
import logo from "../../assets/img/artur_head.svg";

import { Link, useNavigate } from "react-router-dom";
import { Container, Dropdown, Navbar } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faUser, faSignOut } from "@fortawesome/free-solid-svg-icons";
import { faSuitcase, faComment } from "@fortawesome/free-solid-svg-icons";
import jwtDecode from "jwt-decode";
import useLogout from "../../hooks/useLogout";
import useAuth from "../../hooks/useAuth";

function Header() {
  const [token, setToken] = useState();
  const navigate = useNavigate();
  const logout = useLogout();
  const { auth } = useAuth();
  const signOut = async () => {
    await logout();
    navigate("/login");
  };

  let getToken = auth?.accessToken;
  useEffect(() => {
    setToken(getToken);
  }, [getToken]);

  let decodedToken = !token ? "null" : jwtDecode(token);

  const myStyle = {
    backgroundColor: "#414146",
    border: "none",
  };

  return (
    <div>
      <div className="prcHeaderWrap">
        <Navbar className="justify-content-between">
          <Container>
            <ul className="nav align-items-center">
              <li className="nav-item">
                <a href="/" className="navbar-brand">
                  {" "}
                  <img
                    src={logo}
                    alt="Artur.com"
                    title="Artur.com"
                    className="prcLogo"
                  />{" "}
                </a>
              </li>
              <li className="nav-item">
                <Link className="nav-link" to="/vendors">
                  <span>
                    <FontAwesomeIcon icon={faSuitcase} /> Podjetja
                  </span>
                </Link>
              </li>

              <li className="nav-item">
                <Link className="nav-link" to="/reviews">
                  <span>
                    <FontAwesomeIcon icon={faComment} /> Ocene
                  </span>
                </Link>
              </li>
            </ul>
            <ul className="nav align-items-center">
              <Dropdown>
                <Dropdown.Toggle nav caret style={myStyle}>
                  <span>
                    <FontAwesomeIcon icon={faUser} />
                  </span>
                </Dropdown.Toggle>
                <Dropdown.Menu>
                  <Dropdown.Item>
                    <span>
                      {" "}
                      <FontAwesomeIcon icon={faUser} />{" "}
                      {!decodedToken ? "uporabnik" : decodedToken.user_id}
                    </span>
                  </Dropdown.Item>
                  <Dropdown.Divider />
                  <Dropdown.Item>
                    <span onClick={signOut}>
                      {" "}
                      <FontAwesomeIcon icon={faSignOut} /> Odjava{" "}
                    </span>
                  </Dropdown.Item>
                </Dropdown.Menu>
              </Dropdown>
            </ul>
          </Container>
        </Navbar>
      </div>
    </div>
  );
}

export default Header;
